<template>
  <div class="reseller-modal-dimmed">
    <div class="reseller-modal-wrap">
      <div class="reseller-modal">
        <div class="reseller-modal-header">
          <h1>정산 신청 안내</h1>
        </div>
        <div class="reseller-modal-contents">
          <div class="refund-money">
            <p class="price-title">
              <img src="@/assets/images/icon-money.svg" alt="" />정산 금액
            </p>
            <p class="payback">
              <span class="number">{{ calcPrice | currency }}</span> 원
            </p>
          </div>
          <p>
            정산을 신청하신 후에 아래 서류를 모두 제출해 주셔야 정산이
            진행됩니다.<br />정산 금액은 매월 20일경에 등록하신 계좌 정보로
            입금됩니다.
          </p>
          <ul>
            <li>
              ㆍ세금계산서를
              <span v-if="isAdditionalCaculate">전월 말일 자</span
              ><span v-else>당월 11~25일 자</span>로 발급하신 후,
              <a href="mailto:resller-acc@gabia.com" class="underline"
                >reseller-acc@gabia.com</a
              >으로<br />발송해 주세요.
            </li>
            <li>
              ㆍ담당자를 통해 정산받으실 계좌 정보를 등록해 주세요. 등록하신
              경우 추가 등록하지 않고 기존 정보로 입금됩니다.
            </li>
          </ul>
        </div>
        <div class="reseller-modal-footer">
          <p>정산을 신청하시겠습니까?</p>
          <div class="button-area">
            <reseller-button type="primary" @click="$_calculateExecute"
              >확인</reseller-button
            >
            <reseller-button @click="closeModal">취소</reseller-button>
          </div>
        </div>
        <div class="reseller-modal-close" @click="closeModal">
          <i class="fal fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    currency(value) {
      return parseFloat(value)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    }
  },
  props: {
    calcPrice: {
      type: Number,
      required: true
    },
    bankInfo: {
      type: Object,
      required: true
    }
  },

  computed: {
    isAdditionalCaculate() {
      let toDay = new Date();

      return toDay.getDate() <= 25 && toDay.getDate() >= 11 ? false : true;
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal', false);
    },

    $_calculateExecute() {
      if (
        this.bankInfo.accountName == '' ||
        this.bankInfo.accountName == null ||
        this.bankInfo.accountMask == '' ||
        this.bankInfo.accountMask == null ||
        this.bankInfo.bank == '' ||
        this.bankInfo.bank == ''
      ) {
        alert('리셀러 정보에서 정산 계좌 정보를 등록한 후 신청해 주세요.');
        return false;
      }
      let params = {
        calc_price: this.calcPrice.toString(),
        status: '1',
        mail_yn: 'Y'
      };

      this.axios
        .post('/front/calculateExecute', params)
        .then(response => {
          if (response.status != '200') {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
            location.replace('/');
          }
          alert(
            '정산 신청이 완료되었습니다. 세금계산서를 발급하여 reseller-acc@gabia.com 으로 발송해 주시기 바랍니다.'
          );
          this.$emit('closeModal', true);
        })
        .catch(error => {
          console.log('calculate fetchData failed', error);
        });
    }
  }
};
</script>

<style></style>
